export default function Footer() {
  return (
    <footer className="bg-primary-500 text-white py-16 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img
                alt="CareBridge"
                className="h-10 w-auto object-contain rounded-lg"
                src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/ce833f012c3f23716ee4b56643f21003.png"
              />
            </div>
            <p className="text-sm text-white/60 leading-relaxed mb-4">
              Connecting families. Supporting care. The simple app that helps families care for elderly parents.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line text-white/40 text-sm"></i>
                <span className="text-sm text-white/60">123 Care Bridge Way, Austin, TX 78701, USA</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-white/40 text-sm"></i>
                <a href="tel:+15551234567" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">+1 (555) 123-4567</a>
              </div>
            </div>
            <a
              href="mailto:family1st@carebridge.club"
              className="group inline-flex items-center gap-3 mt-5 bg-white/15 hover:bg-white/25 border border-white/25 hover:border-white/40 rounded-2xl px-4 py-3 transition-colors cursor-pointer"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-white text-primary-500 flex-shrink-0">
                <i className="ri-mail-line text-base"></i>
              </span>
              <span className="flex flex-col leading-tight min-w-0">
                <span className="text-[11px] uppercase tracking-wider text-white/60 font-semibold mb-1">Email us anytime</span>
                <span className="text-sm md:text-base font-bold text-white group-hover:underline decoration-white/50 underline-offset-4 break-all">family1st@carebridge.club</span>
              </span>
            </a>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-white/40 mb-4">Product</h4>
            <ul className="space-y-3">
              <li><a href="#solution" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Features</a></li>
              <li><a href="#elderly-dashboard" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">For Seniors</a></li>
              <li><a href="#family-dashboard" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">For Families</a></li>
              <li><a href="#who-it-is-for" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">For Caregivers</a></li>
              <li><a href="#pricing" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Pricing</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-white/40 mb-4">Company</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Blog</a></li>
              <li><a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Careers</a></li>
              <li><a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              <li><a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Press</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-white/40 mb-4">Support</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Help Center</a></li>
              <li><a href="#trust-safety" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Safety</a></li>
              <li><a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Accessibility</a></li>
              <li><a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Privacy Policy</a></li>
              <li><a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">&copy; 2026 CareBridge Inc. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-sm text-white/70"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-sm text-white/70"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-sm text-white/70"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-sm text-white/70"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}